<script>
    import _debounce from 'lodash-es/debounce';
    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';

    import { Swipe } from '../../../../frontend/utils/swipe';

    const swipe = new Swipe();

    let clientWidth = 0;
    let scrollWidth = 0;
    let scrollLeft = 0;
    let shouldShowScrollHint = false;

    let startReached = true;
    let endReached = false;
    let ul;

    function onResizeRaw() {
        scrollWidth = ul && ul.scrollWidth;
        scrollLeft = ul.scrollLeft;
    }

    function onScrollRaw(e) {
        scrollLeft = e.target.scrollLeft;
    }

    function onSwipeChangedRaw({ scrollLeft: newScrollLeft }) {
        scrollLeft = newScrollLeft;
    }

    function onWheel(e) {
        const delta = e.deltaX * 10 || e.deltaY * 2;
        ul.scrollLeft += delta;
    }

    function scrollToLeft() {
        ul.scrollLeft -= 200;
    }

    function scrollToRight() {
        ul.scrollLeft += 200;
    }

    const onResize = _debounce(onResizeRaw, 200);
    const onScroll = _debounce(onScrollRaw, 50);
    const onSwipeChanged = _debounce(onSwipeChangedRaw, 50);

    $: shouldShowScrollHint = clientWidth < scrollWidth;
    $: endReached = scrollLeft + clientWidth >= scrollWidth;
    $: startReached = scrollLeft === 0;

    onMount(() => {
        onResizeRaw();
        ul.addEventListener('scroll', onScroll);
    });

</script>

<svelte:window on:resize={onResize} />
<div
    class="
    horizontal-tabs
    horizontal-tabs--small
    vertical-margin
    vertical-margin--small
"
>
    {#if shouldShowScrollHint && !startReached}
        <div
            class="scroll-hint scroll-hint--left"
            transition:fade
            on:click={scrollToLeft}
        >
            &lt;
        </div>
    {/if}
    <ul
        class="ghwp-tab-list ghwp-tab-list--maps"
        class:with-hint={shouldShowScrollHint}
        bind:clientWidth
        bind:this={ul}
        on:wheel={onWheel}
        use:swipe.attach={{ onSwipeChanged }}
    >
        <slot />
    </ul>
    {#if shouldShowScrollHint && !endReached}
        <div
            class="scroll-hint scroll-hint--right"
            transition:fade
            on:click={scrollToRight}
        >
            &gt;
        </div>
    {/if}
</div>

<style>
    .horizontal-tabs {
        position: relative;
    }

    .horizontal-tabs ul.ghwp-tab-list {
        flex-wrap: nowrap;
        overflow: hidden;
        scroll-behavior: smooth;
        scroll-snap-type: x mandatory;
    }

    .scroll-hint {
        position: absolute;
        top: 0;
        background-image: linear-gradient(
            90deg,
            transparent 0%,
            #fff 30%,
            #fff 100%
        );
        bottom: 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3rem;
        z-index: 1;
    }

    .scroll-hint:hover {
        color: blue;
    }

    .scroll-hint.scroll-hint--right {
        right: 0;
        background-image: linear-gradient(
            90deg,
            transparent 0%,
            #fff 30%,
            #fff 100%
        );
    }

    .scroll-hint.scroll-hint--left {
        left: 0;
        background-image: linear-gradient(
            90deg,
            #fff 0%,
            #fff 70%,
            transparent 100%
        );
    }

</style>
